import axiosInstance from './client'

export interface CaisseVirementInfo {
  rib?:          string
  banque?:       string
  nomTitulaire?: string
  dateVirement?: string
  reference?:    string
}

export interface Caisse {
  _id:                string
  type:               'day' | 'week'
  dateDebut:          string
  dateFin:            string
  totalColisAssignes: number
  totalColisLivres:   number
  montantBrut:        number
  gainLivreur:        number
  commissionTariqGo:  number
  montantNet:         number
  statut:             'ouverte' | 'cloturee' | 'payee'
  modePaiement?:      'cash' | 'virement'
  virementInfo?:      CaisseVirementInfo
  livreur?: {
    name:      string
    phone:     string
    bankInfo?: {
      rib?:          string
      banque?:       string
      nomTitulaire?: string
    }
  }
  createdAt?: string
}

export interface CaisseHistorique {
  caisses:    Caisse[]
  pagination: { total: number; page: number; limit: number; totalPages: number }
}

export interface JourneeExpediteur {
  date:           string
  statut:         'ouverte' | 'cloturee'
  colisLivres:    number
  montantJournee: number
}

export const caissesAPI = {
  getMaCaisse: async (type: 'day' | 'week'): Promise<Caisse> => {
    const { data } = await axiosInstance.get('/caisses/moi', { params: { type } })
    return data
  },

  getHistorique: async (type: 'day' | 'week', page = 1): Promise<CaisseHistorique> => {
    const { data } = await axiosInstance.get('/caisses/historique', { params: { type, page } })
    return data
  },

  saveBankInfo: async (
    caisseId: string,
    info: { rib: string; banque: string; nomTitulaire: string }
  ) => {
    const { data } = await axiosInstance.patch(`/caisses/${caisseId}/bankinfo`, info)
    return data
  },

  getJourneeExpediteur: async (date?: string): Promise<JourneeExpediteur> => {
    const { data } = await axiosInstance.get('/caisses/expediteur/journee', {
      params: date ? { date } : undefined,
    })
    return data
  },

  getAllAdmin: async (params: {
    type?: 'day' | 'week'
    statut?: string
    page?: number
    livreur?: string
  }): Promise<{ caisses: Caisse[]; pagination: { total: number; page: number; limit: number; totalPages: number } }> => {
    const { data } = await axiosInstance.get('/caisses/admin', { params })
    return data
  },

  cloturerCaisse: async (id: string) => {
    const { data } = await axiosInstance.post(`/caisses/${id}/cloturer`)
    return data
  },

  marquerPayee: async (id: string, info: { reference?: string; dateVirement?: string }) => {
    const { data } = await axiosInstance.post(`/caisses/${id}/marquer-payee`, info)
    return data
  },
}
